import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = {
  key: 0,
  class: "customer-form"
}
const _hoisted_4 = { class: "collapse-content" }
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "collapse-content" }
const _hoisted_8 = { class: "new-form" }
const _hoisted_9 = { class: "monospace" }
const _hoisted_10 = { class: "pager" }
const _hoisted_11 = { class: "footer" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_Ticket = _resolveComponent("Ticket")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_View = _resolveComponent("View")
  const _component_el_button = _resolveComponent("el-button")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _component_Checked = _resolveComponent("Checked")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TICKETLIST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TKLS_SELECT'] && !_ctx.loading]
        ]),
        (_ctx.hasPermission['TKLS_SELECT'])
          ? (_openBlock(), _createBlock(_component_el_container, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_main, { class: "rounded-content" }, {
                  default: _withCtx(() => [
                    (!_ctx.isCustomer)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _createVNode(_component_el_form_item, {
                            label: "Mandant",
                            prop: "customerid"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.customerId,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.customerId) = $event)),
                                placeholder: "Bitte wählen ...",
                                onChange: _ctx.onCustomerChange
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.customerModelList, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.customerid,
                                      label: item.name,
                                      value: item.customerid
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_collapse, {
                      modelValue: _ctx.activeName,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.activeName) = $event)),
                      accordion: "",
                      ref: "coll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_collapse_item, { name: "1" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_4, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Ticket)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "title-label" }, "Ticketlisten", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_5, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.tokenlistModelList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "tokenlistid",
                                    label: "ID",
                                    width: "80"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "name",
                                    label: "Bezeichnung",
                                    width: "300"
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "valid_from",
                                    label: "Gültig ab"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.tokenlistModelList[scope.$index].valid_from))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "valid_until",
                                    label: "Gültig bis"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.tokenlistModelList[scope.$index].valid_until))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "token_count",
                                    label: "Anzahl Teilnahme-IDs",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(_ctx.tokenlistModelList[scope.$index].token_count), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateinsert",
                                    label: "Erstellt am",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.tokenlistModelList[scope.$index].dateinsert))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        onClick: $event => (_ctx.onShowTicketlist(_ctx.tokenlistModelList[scope.$index])),
                                        circle: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_icon, { size: 16 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_View)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.hasPermission['TKLS_DELETE'])
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        fixed: "right",
                                        label: "",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_button, {
                                            type: "danger",
                                            onClick: $event => (_ctx.onTicketlistDeleteClick(_ctx.tokenlistModelList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Delete)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.hasPermission['TKLS_INSERT'])
                          ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                              key: 0,
                              name: "2"
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_el_icon, { size: 32 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_CirclePlusFilled)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title-label" }, "Neue Ticketliste", -1))
                              ]),
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                  _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_el_form, {
                                      ref: "newTicketForm",
                                      rules: _ctx.rules,
                                      "label-position": "top",
                                      model: _ctx.newTicketlistModel,
                                      "label-width": "120px"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_form_item, {
                                          label: "Name",
                                          prop: "name"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input, {
                                              modelValue: _ctx.newTicketlistModel.name,
                                              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.newTicketlistModel.name) = $event)),
                                              onInput: _ctx.onTicketlistInput
                                            }, null, 8, ["modelValue", "onInput"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "Gültig ab" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: _ctx.validFrom,
                                              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.validFrom) = $event)),
                                              type: "date",
                                              placeholder: "Bitte wählen...",
                                              format: "DD.MM.YYYY",
                                              onChange: _ctx.onTicketlistInput
                                            }, null, 8, ["modelValue", "onChange"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "Gültig bis" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_date_picker, {
                                              modelValue: _ctx.validUntil,
                                              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.validUntil) = $event)),
                                              type: "date",
                                              placeholder: "Bitte wählen...",
                                              format: "DD.MM.YYYY",
                                              onChange: _ctx.onTicketlistInput
                                            }, null, 8, ["modelValue", "onChange"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, { label: "Anzahl Tickets" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_input_number, {
                                              modelValue: _ctx.numberOfTickets,
                                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.numberOfTickets) = $event)),
                                              min: 1,
                                              max: 100000,
                                              onInput: _ctx.onTicketlistInput
                                            }, null, 8, ["modelValue", "onInput"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_el_form_item, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_button, {
                                              type: "primary",
                                              disabled: !_ctx.formTicketlistValid || _ctx.loading,
                                              loading: _ctx.loading,
                                              onClick: _ctx.onNewTicketlistClick
                                            }, {
                                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                _createTextVNode("Hinzufügen ")
                                              ])),
                                              _: 1
                                            }, 8, ["disabled", "loading", "onClick"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["rules", "model"])
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: 'Ticketliste: ' + _ctx.ticketListName,
      modelValue: _ctx.showTickets,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.showTickets) = $event)),
      width: "80%",
      top: "60px",
      loading: "loadingTokens"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: _ctx.tokenModelList,
          height: "450",
          loading: "loadingTokens"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              property: "token",
              label: "Teilnahme-ID"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.tokenModelList[scope.$index].prefix + '-' + _ctx.tokenModelList[scope.$index].token), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Registriert",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _withDirectives(_createVNode(_component_el_icon, { size: 28 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Checked)
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, _ctx.tokenModelList[scope.$index].isregistered > 0]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Eingelöst",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _withDirectives(_createVNode(_component_el_icon, { size: 28 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Checked)
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, _ctx.tokenModelList[scope.$index].isused > 0]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "Abgeschlossen",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _withDirectives(_createVNode(_component_el_icon, { size: 28 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Checked)
                  ]),
                  _: 2
                }, 1536), [
                  [_vShow, _ctx.tokenModelList[scope.$index].isdone > 0]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_pagination, {
            small: "",
            background: "",
            layout: "prev, pager, next",
            "page-size": _ctx.tokenCount,
            total: _ctx.tokenTableCount,
            onCurrentChange: _ctx.onPageChange
          }, null, 8, ["page-size", "total", "onCurrentChange"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_ctx.hasPermission['TKLS_UPDATE'])
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                fixed: "right",
                label: "Tickets ergänzen"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input_number, {
                    modelValue: _ctx.numberOfAdditionalTickets,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.numberOfAdditionalTickets) = $event)),
                    min: 1,
                    max: 100000
                  }, null, 8, ["modelValue"]),
                  _cache[13] || (_cache[13] = _createTextVNode("  ")),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    disabled: _ctx.loading,
                    loading: _ctx.loading,
                    onClick: _ctx.onAddTicketsClick
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode("Hinzufügen")
                    ])),
                    _: 1
                  }, 8, ["disabled", "loading", "onClick"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}